import * as Yup from 'yup';
import checkoutFormModel from './formModel';

const moment = require('moment');

const {
    formField: {
        motovehiculo: {
            marca,
            anio,
            version,
            valorAdicional,
            ceroKm,
        },
        situacionImpositiva,
        tipoPersona,
        codigosLocalidad,
        vigencia,
        ajusteAutomatico,
        cuotas,
        afinidad,
        // fechaCotizacion
    }
} = checkoutFormModel;


export default [
    Yup.object().shape({
        motovehiculo: Yup.object().shape({
            marca: Yup.string().required(`${marca.requiredErrorMsg}`),
            ceroKm: Yup.string().required(`${ceroKm.requiredErrorMsg}`),
            anio: Yup.number()
                .required(`${anio.requiredErrorMsg}`)
                .integer()
                .min(2001, "El año ingresado es muy antiguo")
                .max(moment().format("YYYY"), "Ingrese un año válido")
                .typeError("Ingrese un año válido"),
            version: Yup.string().required(`${version.requiredErrorMsg}`),
            valorAdicional: Yup.number()
                .required(`${valorAdicional.requiredErrorMsg}`)
                .min(0, "El valor no puede ser negativo")
                .max(10000000, "El monto máximo es $10.000.000")
        }),
    }),
    Yup.object().shape({
        [situacionImpositiva.name]: Yup.string().required(`${situacionImpositiva.requiredErrorMsg}`),
        [tipoPersona.name]: Yup.string().required(`${tipoPersona.requiredErrorMsg}`),
        [codigosLocalidad.name]: Yup.string().required(`${codigosLocalidad.requiredErrorMsg}`),
        [afinidad.name]: Yup.string().required(`${afinidad.requiredErrorMsg}`),
    }),
    Yup.object().shape({
        [ajusteAutomatico.name]: Yup.string().when([vigencia.name], {
            is: '2',
            then: Yup.string().required(`${ajusteAutomatico.requiredErrorMsg}`)
        }),
        [cuotas.name]: Yup.string().when([vigencia.name], {
            is: '2',
            then: Yup.string().required(`${cuotas.requiredErrorMsg}`)
        }),
        // [fechaCotizacion.name]: Yup.date()
        //     .required(`${fechaCotizacion.requiredErrorMsg}`)
        //     .min(moment().format('YYYY-MM-DD'), "La fecha no puede ser anterior al dia de hoy")
        //     .max(moment().add(45, "days").format('YYYY-MM-DD'), "La fecha no puede superar los 45 dias"),
    })
];
